import { useState } from "react";
import { Copy, Check } from "lucide-react";

export const CopyButton = ({ value, tid, label }) => {
  const [done, setDone] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(value);
    setDone(true);
    setTimeout(() => setDone(false), 1500);
  };
  return (
    <button onClick={copy} data-testid={tid} className="inline-flex items-center gap-1 text-xs text-slate-300 hover:text-white rounded-lg border border-white/10 px-2 py-1 transition-colors" aria-label={`Copy ${label || value}`}>
      {done ? <Check size={12} className="text-emerald-400" /> : <Copy size={12} />} {label || (done ? "Copied" : "Copy")}
    </button>
  );
};

export const addFlameToWallet = async (address) => {
  if (!window.ethereum) throw new Error("No wallet found");
  return window.ethereum.request({
    method: "wallet_watchAsset",
    params: { type: "ERC20", options: { address, symbol: "FLAME", decimals: 18, image: `${window.location.origin}/brand/flame-256.png` } },
  });
};
